import { LogOut, PanelRightClose, PanelRightOpen } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useSession } from "@/hooks/auth-hooks";
import { authClient } from "@/lib/auth-client";

interface AdminHeaderProps {
	sidebarCollapsed: boolean;
	onToggleSidebar: () => void;
}

export function AdminHeader({
	sidebarCollapsed,
	onToggleSidebar,
}: AdminHeaderProps) {
	const { t } = useTranslation();
	const { data: session } = useSession();

	const handleSignOut = async (): Promise<void> => {
		await authClient.signOut();
		window.location.href = "/";
	};

	return (
		<header className="flex h-14 flex-shrink-0 items-center justify-between border-b bg-background px-4">
			<div className="flex items-center gap-4">
				<Button
					variant="ghost"
					size="icon"
					onClick={onToggleSidebar}
					className="h-8 w-8"
				>
					{sidebarCollapsed ? (
						<PanelRightClose className="h-5 w-5" />
					) : (
						<PanelRightOpen className="h-5 w-5" />
					)}
				</Button>
				<h2 className="text-muted-foreground text-sm">
					{t("auth:admin_only")}
				</h2>
			</div>
			<div className="flex items-center gap-4">
				<div className="flex items-center gap-3">
					<Avatar className="h-8 w-8">
						<AvatarFallback>
							{session?.user?.name?.charAt(0).toUpperCase() ?? "A"}
						</AvatarFallback>
					</Avatar>
					<div className="flex flex-col">
						<span className="font-medium text-sm">{session?.user?.name}</span>
						<span className="text-muted-foreground text-xs">
							{session?.user?.email}
						</span>
					</div>
				</div>
				<Button variant="ghost" size="icon" onClick={handleSignOut}>
					<LogOut className="h-5 w-5" />
				</Button>
			</div>
		</header>
	);
}
